import { useEffect } from "react";

const MessagesClient = () => {
  useEffect(() => {
    document.title = "Сообщения | В разработке";
  }, []);
  return null;
};

export default MessagesClient;
